import { render, staticRenderFns } from "./AddSignatoriesDialog.vue?vue&type=template&id=62bc1827"
import script from "./AddSignatoriesDialog.vue?vue&type=script&lang=js"
export * from "./AddSignatoriesDialog.vue?vue&type=script&lang=js"
import style0 from "./AddSignatoriesDialog.vue?vue&type=style&index=0&id=62bc1827&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports